export const getTitleFromId = (propertyId: string) => {
  return propertyId === "iNANAwfMb6EXNtp7MRwJ"
    ? "Runbhumi Mewar"
    : "Velocity Turf";
};
